import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { ChevronLeft, ChevronRight } from 'react-feather';

import { ShortBody } from 'components/Typography';
import { pushTo } from 'helpers/routes';
import { ContentWrapper } from 'components/HeaderRecovery/styles';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

const HeaderRecovery = (props: any) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  return (
    <Box paddingY={2} paddingX={[3, 6, 9]}>
      <ContentWrapper
        data-testid="return-button"
        container
        spacing={1}
        onClick={() => pushTo('/')}
      >
        <Grid item>{reverse ? <ChevronRight /> : <ChevronLeft />}</Grid>
        <Grid item>
          <ShortBody weight="500">{props.title}</ShortBody>
        </Grid>
      </ContentWrapper>
    </Box>
  );
};

export default HeaderRecovery;
